export default "__VITE_ASSET__DvVR_RmZ__";